import { Injectable } from '@angular/core';
import { IntroJs } from 'intro.js';
const introJs = require('intro.js/intro.js');

@Injectable({
  providedIn: 'any',
})
export class IntroService {
  public createInstance(): IntroJs {
    return introJs();
  }
}
